import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const CGU = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand-50">
      <div className="bg-white border-b border-sand-200 px-6 py-4 sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-serif text-sage-700">Conditions Générales d'Utilisation</h1>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto prose prose-sage">
        <p className="text-sm text-sage-500">Dernière mise à jour : Avril 2026</p>

        <h2>Article 1 - Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation 
          de l'application web "Déclic RePas" accessible à l'adresse app-declic-repas.fr.
        </p>

        <h2>Article 2 - Accès à l'application</h2>
        <p>
          L'accès à l'application nécessite :
        </p>
        <ul>
          <li>La création d'un compte utilisateur avec une adresse email valide</li>
          <li>Un code d'accès valide obtenu après achat du programme</li>
          <li>Une connexion internet</li>
        </ul>

        <h2>Article 3 - Compte utilisateur</h2>
        <p>
          Chaque utilisateur est responsable de la confidentialité de ses identifiants de connexion. 
          Il s'engage à ne pas partager son compte ni son code d'accès avec des tiers.
        </p>

        <h2>Article 4 - Utilisation du contenu</h2>
        <p>
          Le contenu de l'application (audios, textes, outils) est destiné à un usage personnel 
          et privé uniquement. Il est strictement interdit de :
        </p>
        <ul>
          <li>Télécharger le contenu à des fins de partage ou de revente</li>
          <li>Copier, reproduire ou diffuser le contenu</li>
          <li>Utiliser le contenu à des fins commerciales</li>
          <li>Partager son accès avec des tiers</li>
        </ul>

        <h2>Article 5 - Comportement de l'utilisateur</h2>
        <p>
          L'utilisateur s'engage à utiliser l'application de manière responsable et à ne pas 
          perturber son fonctionnement.
        </p>

        <h2>Article 6 - Disponibilité</h2>
        <p>
          L'éditeur s'efforce de maintenir l'application accessible 24h/24, mais ne peut garantir 
          une disponibilité permanente. Des interruptions pour maintenance peuvent survenir.
        </p>

        <h2>Article 7 - Avertissement santé</h2>
        <p>
          Le programme "Déclic RePas" est un programme de développement personnel basé sur 
          l'hypnose et les neurosciences. <strong>Il ne constitue pas un traitement médical</strong> et 
          ne remplace en aucun cas une consultation médicale ou psychologique.
        </p>
        <p>
          En cas de troubles alimentaires diagnostiqués (anorexie, boulimie, etc.) ou de 
          problèmes de santé, consultez un professionnel de santé.
        </p>

        <h2>Article 8 - Modification des CGU</h2>
        <p>
          L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les 
          utilisateurs seront informés des modifications.
        </p>

        <h2>Article 9 - Résiliation</h2>
        <p>
          En cas de non-respect des présentes CGU, l'éditeur se réserve le droit de suspendre 
          ou résilier l'accès de l'utilisateur sans préavis ni remboursement.
        </p>

        <h2>Contact</h2>
        <p>
          Pour toute question : brylynda@gmail.com
        </p>
      </div>
    </div>
  );
};

export default CGU;
